const $01a0d922e623affe$var$menu = document.querySelector('[data-menu]');
const $01a0d922e623affe$var$menuBtn = document.querySelector('[data-menu-btn]');
const $01a0d922e623affe$var$links = document.querySelectorAll('[data-mobile-link]');
const $01a0d922e623affe$var$handleMenu = ()=>{
    $01a0d922e623affe$var$menu.classList.toggle('is-open');
    $01a0d922e623affe$var$menuBtn.classList.toggle('is-open');
};
$01a0d922e623affe$var$links.forEach((link)=>{
    link.addEventListener('click', ()=>{
        $01a0d922e623affe$var$menu.classList.remove('is-open');
        $01a0d922e623affe$var$menuBtn.classList.remove('is-open');
    });
});
$01a0d922e623affe$var$menuBtn.addEventListener('click', $01a0d922e623affe$var$handleMenu);


const $99cf614151e86eeb$var$modal = document.querySelector('[data-order-modal]');
const $99cf614151e86eeb$var$openBtn = document.querySelector('[data-order-modal-open]');
const $99cf614151e86eeb$var$closeBtn = document.querySelector('[data-order-modal-close]');
console.log($99cf614151e86eeb$var$modal, $99cf614151e86eeb$var$openBtn, $99cf614151e86eeb$var$closeBtn);
const $99cf614151e86eeb$var$handleToggleModal = ()=>{
    $99cf614151e86eeb$var$modal.classList.toggle('is__hidden');
    document.body.classList.toggle('no-scroll');
};
$99cf614151e86eeb$var$openBtn.addEventListener('click', $99cf614151e86eeb$var$handleToggleModal);
$99cf614151e86eeb$var$closeBtn.addEventListener('click', $99cf614151e86eeb$var$handleToggleModal);


const $7a61cd872e2df962$var$controls = document.querySelector('[data-reviews-slide-nav]');
const $7a61cd872e2df962$var$slider = document.querySelector('[data-reviews-slide-container]');
const $7a61cd872e2df962$var$handleChancheSlide = (event)=>{
    const target = event.target;
    if (!target) return;
    if (target.tagName === 'BUTTON') {
        const index = target.dataset.slide;
        const translateX = `translateX(-${index}00%)`;
        $7a61cd872e2df962$var$slider.style.transform = translateX;
        $7a61cd872e2df962$var$controls.querySelectorAll('[data-slide]').forEach((btn)=>{
            btn.classList.remove('toggle-nav__button--active');
        });
        target.classList.add('toggle-nav__button--active');
    }
};
$7a61cd872e2df962$var$controls.addEventListener('click', $7a61cd872e2df962$var$handleChancheSlide);


const $48b5994590efc900$var$controls = document.querySelector('[data-slide-nav]');
const $48b5994590efc900$var$slider = document.querySelector('[data-slide-container]');
console.log($48b5994590efc900$var$controls, $48b5994590efc900$var$slider);
const $48b5994590efc900$var$handleChancheSlide = (event)=>{
    const target = event.target;
    if (!target) return;
    console.log(target);
    if (target.tagName === 'BUTTON') {
        const index = target.dataset.slide;
        const translateX = `translateX(-${index}00%)`;
        $48b5994590efc900$var$slider.style.transform = translateX;
        $48b5994590efc900$var$controls.querySelectorAll('[data-slide]').forEach((btn)=>{
            btn.classList.remove('toggle-nav__button--active');
        });
        target.classList.add('toggle-nav__button--active');
    }
};
$48b5994590efc900$var$controls.addEventListener('click', $48b5994590efc900$var$handleChancheSlide);




//# sourceMappingURL=bose.756c509c.js.map
